import * as yup from 'yup'
import constants from 'constants/index'

const allowedTypes = constants.cookies.banner.SUPPORTED_IMAGE_FILE_INPUT_TYPES

export const bannerConfigurationSchema = yup.object({
  name: yup.string().min(4).max(150).required(),
  status: yup.string().nullable(),
  privacyPolicyLink: yup.string().nullable(),
  cookiesPolicyLink: yup.string().nullable(),
  domain: yup.string().nullable(),
  urls: yup
    .array()
    .transform((value, originalValue) => originalValue || [])
    .of(
      yup.object().shape({
        url: yup.string().min(4).max(256).url('URL inválida').required(),
        id: yup.string().nullable(),
      }),
    )
    .min(1),
})

export const bannerAppearanceSchema = yup.object({
  primaryColor: yup.string().required().min(4).max(7),
  secondaryColor: yup.string().required().min(4).max(7),
  fontFamily: yup.string(),
  logo: yup.mixed().fileUpload({
    sizeLimit: 5,
    unit: 'MB',
    types: allowedTypes,
    mimeTypes: constants.cookies.banner.SUPPORTED_IMAGE_FILE_SCHEMA_TYPES,
    sizeMessage: 'A imagem deve ter no máximo 5 MB',
  }),
})

export const bannerLayoutSchema = yup.object({
  position: yup.string().required(),
  hideOnAccept: yup.boolean(),
  hideRejectButton: yup.boolean(),
  privacyPortalEnabled: yup.boolean(),
  privacyPortalUrl: yup
    .string()
    .nullable()
    .when('privacyPortalEnabled', {
      is: true,
      then: yup
        .string()
        .trim()
        .url('URL inválida')
        .max(256, 'URL deve ter no máximo 256 caracteres')
        .required('Link é obrigatório quando exibição está ativada'),
      otherwise: yup.string().nullable(),
    }),
})

export const ageGateSchema = yup.object({
  ageGateEnabled: yup.boolean(),
  ageGateMinimumAge: yup
    .number()
    .nullable()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .when('ageGateEnabled', {
      is: true,
      then: yup.number().required().min(1).max(120),
      otherwise: yup.number().nullable(),
    }),
  ageGateOverlayOpacity: yup.number().min(0).max(100),
  ageGateBlockingAction: yup.string().nullable(),
  ageGateRedirectUrl: yup
    .string()
    .nullable()
    .when('ageGateBlockingAction', {
      is: constants.cookies.ageGateTextOverride.BLOCKING_ACTION_REDIRECT,
      then: yup
        .string()
        .trim()
        .url('URL inválida')
        .required('URL é obrigatória'),
      otherwise: yup.string().nullable(),
    }),
})

export const cookieScannerSchema = yup.object({
  scannerUrlId: yup.string(),
})
